<template>
    <vehicles />
  </template>
  
  <script>
  import vehicles from "@/components/3pl/Settings/Vehicles/ViewVehicle/index.vue";
  export default {
    components: {
      vehicles,
    },
  };
  </script>
  
  <style></style>
  